import type { GenerationTool } from 'src/data/generationTool';
// @ts-expect-error - useTextAnnotationsDebounced has no TypeScript declarations
import { useTextAnnotationsDebounced } from 'src/services/useTextAnnotationsDebounced';

import { LONG_FORM_INSIGHTS_DEBOUNCE_TIMEOUT } from './longFormConst';

interface Params {
  customerId?: string;
  generationTool?: GenerationTool | null;
  text: string;
}

export const useLongFormAnnotationsData = ({ customerId, generationTool, text }: Params) => {
  return useTextAnnotationsDebounced(
    { customerId, generationTool, text },
    { debounceTimeout: LONG_FORM_INSIGHTS_DEBOUNCE_TIMEOUT }
  );
};
